import Checkboxes from 'components/Formik/Checkboxes';

const ConsentRelease = ({ initialValues, data }) => {
	initialValues.iconfirmthatIhaveread = [];
	const { options } = data;
	return (
		<Checkboxes
			options={options}
			label='iconfirmthatIhaveread'
			name='iconfirmthatIhaveread'
			parse
		/>
	);
};

export default ConsentRelease;
